// config.js

// Paddle BearToken
export const config = {
  token: 'c17913d0a425e8db7274b3188d09bfd0c381e17f82207db908',
  apiUrl: 'https://api.lemonsqueezy.com',
  apiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NGQ1OWNlZi1kYmI4LTRlYTUtYjE3OC1kMjU0MGZjZDY5MTkiLCJqdGkiOiI5YmI3NmIwOWM4MjliZGEzOTUwZTQ5MzEzZTdlM2E3Y2FjZTE4Y2QxNDBjYThjOGMyNTcwMWU3NWU1ZGQyYzI3YWE3ODRiOTI2N2RjMDM5MCIsImlhdCI6MTcyMjMxOTMxMi42OTI4NDMsIm5iZiI6MTcyMjMxOTMxMi42OTI4NDUsImV4cCI6MjAzNzg1MjExMi42NTcxNTQsInN1YiI6IjQyNDE2NiIsInNjb3BlcyI6W119.BezEtFEeIWjVhZV21Msuz9QdSUQRdjNFPMiz_Clws7XSgP4Jx5aGY9Hr51mUzmtauFCe9gTFa6XRjO-kPhzD5kgxqik25Q_CI4cpZwlUWSLfA6-cWBhRi5RLwPIWMDaCtICvw-TvM3xmKlJDgonXlhDYfpZZwh4bbDE0XepzlbY5tN6ggRkQUXOfxKrySVcmn0FOH4NVJIfLvyNVK0a96sThOo_8LgJ8cicn7rpBPACwGvacYesK_Q9vFusCEjWxvvlrzh_tU8u8AeUGXbALOY7SU1lRv0tZw32HAUeEEgxVUOPLXR7DLafGMT0bUdvPWE9l7Y5Kz5WEem0SETgagLyRlQzUN2gaOGkuC-1sXs4Tuj2rk9zvUcNNL2f8leX04V9kFZoa8mJXBFyP18CxokuP_rWDcQ73pPHICj3r_ieIgoXv71hy8q6MHQ8QoGACyAN64ok7dhkHxGyKTd876sKznoEc29OpcNAe9QftHqZUnQZYnkjt9Rmao0BrRYdz'
};


export const productDaysMap = {
  "DailyPlan": 1,
  "MonthlyVIP": 32,
  "QuartelyVIP": 96,
  "AnnualVIP": 366
};